import useGetPlayerEl from 'chameleon/packages/blue-book-player/hooks/useGetPlayerEl';
import { SELECTORS } from 'chameleon/packages/blue-book-player/constants/selectors';
import { canAnnotate } from 'chameleon/packages/blue-book-player/Annotation/utils';
import { HIGHLIGHT_COLORS_NAMES } from '../constants';

const useHighlights = () => {
  const playerEl = useGetPlayerEl();

  const applyHighlight = (selection) => {
    const isAnnotationAllowed = canAnnotate(selection);
    playerEl.classList.toggle('can-annotate', isAnnotationAllowed);
    if (!isAnnotationAllowed) {
      return;
    }

    const currentHighlightButton = playerEl.querySelector(
      SELECTORS.HIGHLIGHT_BUTTON,
    );
    currentHighlightButton?.click();
  };

  const selectColor = (color = HIGHLIGHT_COLORS_NAMES.YELLOW) => {
    const currentExpandColorsButton = playerEl.querySelector(
      SELECTORS.EXPAND_COLORS_BUTTON,
    );
    currentExpandColorsButton?.click();

    const colorButton = playerEl.querySelector(SELECTORS.COLOR_BUTTON(color));
    colorButton?.click();
  };

  const removeHighlight = () => {
    const currentRemoveHighlightButton = playerEl.querySelector(
      SELECTORS.REMOVE_HIGHLIGHT_BUTTON,
    );
    currentRemoveHighlightButton?.click();
  };

  return {
    applyHighlight,
    selectColor,
    removeHighlight,
  };
};

export default useHighlights;
